import "./App.css";
import React ,{useEffect}from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { refreshToken } from "./services/operations/authAPI";
import { Navigate } from 'react-router-dom';
import { motion } from "framer-motion";
// Pages & Components
import HomePage from './pages/HomePage';
import Navbar from "./component/common/Navbar"
import OpenRoute from "./component/core/Auth/OpenRoute"
import PrivateRoute from "./component/core/Auth/PrivateRoute";
// import Signup from './pages/Signup';
import { useDispatch, useSelector } from "react-redux";
import Signup from './components/Signup/Signup';
import FeaturesPage from './pages/FeaturesPage';
// import Login from './pages/Login';
import Login from './components/Login/Login';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeSignup from './pages/EmployeeSignup';
// import EmployeeDashboard from './pages/EmployeeDashboard';
import Sidebar from './components/Sidebar/Sidebar';
import NodeCreationPage from './pages/NodeCreationPage'
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import UpdatePassword from "./pages/UpdatePassword";
import MainContent from './components/MainContent/MainContent';
import UserProfile from './components/UserProfile/UserProfile';
import EditProfile from './components/EditProfile/EditProfile';
import Button from "./components/Button/Button";
import Worksheet from './components/Worksheet/Worksheet';
import WorksheetPage from './pages/WorksheetPage';
import DownloadPage from './pages/DownloadPage';
// import About from "./page/About";
// import Contact from "./page/Contact";
import Error from "./page/Error"
import MyProfile from "./component/core/Dashboard/MyProfile";
import Dashboard from "./page/Dashboard";
import Settings from "./component/core/Dashboard/Settings";
import { ACCOUNT_TYPE } from "./utils/constants";
import AdminDashboarddemo from './pages/admin/AdminDashboard';
import CreateTeam from './pages/admin/CreateTeam';
import EmployeeDashboard from './pages/employee/EmployeeDashboard';
import TaskAssigned from './pages/employee/TaskAssigned';
import ViewNodes from './pages/employee/ViewNodes';
import WorksheetsPage from './pages/employee/WorksheetPage';
import MyTeam from './pages/admin/MyTeam';
import Information from './pages/Information'
import ViewDrawingsheet from './pages/admin/ViewDrawingsheet';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Scroll_To_Top_Button from "./utils/Scroll_To_Top_Button"
import SuperAdminDashboard from './pages/superAdmin/SuperAdminDashboard';
import Plants from './pages/superAdmin/PlantManagement';
import AIHazopPage from './pages/employee/AIHazopPage';
import AIWorksheet from './pages/employee/AIWorkSheet';
export default function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { user } = useSelector((state) => state.profile)
  const { loading: authLoading } = useSelector((state) => state.auth);
  const { loading: profileLoading } = useSelector((state) => state.profile);

  useEffect(() => {

    dispatch(refreshToken());
  }, [dispatch]);
  const load=true
  // Wait until refreshToken completes before rendering routes
  if (authLoading || profileLoading) {
    return (
      <div className="min-h-screen w-screen bg-gradient-to-br  flex items-center justify-center relative overflow-hidden">
        {/* Animated background */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>
        
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center relative z-10"
        >
          <div className="relative mb-8">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              className="w-20 h-20 mx-auto"
            >
              <div className="w-full h-full border-4 border-blue-500/30 border-t-blue-500 rounded-full"></div>
            </motion.div>
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="absolute inset-0 w-20 h-20 mx-auto bg-blue-500/20 rounded-full blur-xl"
            ></motion.div>
          </div>
          
          <motion.h2 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-3xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent mb-4"
          >
            Loading...
          </motion.h2>
          
          
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="flex justify-center space-x-2 mt-6"
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ duration: 1, repeat: Infinity, delay: i * 0.2 }}
                className="w-2 h-2 bg-blue-400 rounded-full"
              />
            ))}
          </motion.div>
        </motion.div>
      </div>
    );
  }



  return (
    <div className="w-screen min-h-screen flex flex-col font-inter relative ">
      <Navbar/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<OpenRoute><Signup /></OpenRoute>} />
        <Route path="/employee/signup/:token" element={<OpenRoute><Signup /></OpenRoute>} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/success" element={<Success />} />
        <Route path="/failure" element={<Cancel />} />
        <Route path="/login" element={<OpenRoute><Login /></OpenRoute>} />
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route
          path="update-password/:id"
          element={
            <OpenRoute>
              <UpdatePassword />
            </OpenRoute>
          }
        />  
        <Route path="/employee-signup/:token" element={<OpenRoute><Signup /></OpenRoute>} />
        <Route element={<PrivateRoute><Dashboard /></PrivateRoute>}>
        <Route path="dashboard/my-profile" element={<MyProfile />} />
        <Route path="dashboard/Settings" element={<Settings />} />
        <Route path="dashboard/info" element={<Information />} />
        <Route path="/dashboard/node/:nodeId/worksheets" element={<WorksheetsPage />}/>
        <Route path="/dashboard/node/:nodeId/aiWorksheet" element={<AIWorksheet />}/>
        <Route path="/dashboard/download/:nodeNumber" element={<DownloadPage />} />
        <Route path="/dashboard/employee/view-nodes/:drawingSheetId" element={<ViewNodes />}/>
        <Route path="/dashboard/ai-hazop" element={<AIHazopPage />}/>
        {
        user?.accountType === ACCOUNT_TYPE.EMPLOYEE && (
          <>
          <Route path="dashboard/employee" element={<EmployeeDashboard/>}/>
          <Route path="dashboard/task-assigned" element={<TaskAssigned/>}/>
          
          

          </>
        )
      }

      {
        user?.accountType === ACCOUNT_TYPE.ADMIN && (
          <>
          <Route path="dashboard/admin" element={<AdminDashboarddemo />} />
          <Route path="dashboard/create-team" element={<CreateTeam />} />
          <Route path="/dashboard/my-team" element={<MyTeam />} />
          
          <Route path="/dashboard/view-drawingsheet" element={<ViewDrawingsheet />} />
          
          
          </>
        )
      }

      {
        user?.accountType===ACCOUNT_TYPE.SUPERADMIN && (
          <>
          <Route path="/dashboard/superadmin" element={<SuperAdminDashboard />} />
          <Route path="/plants" element={<Plants />} />
          </>
        )
      }

        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <Scroll_To_Top_Button/>
      </div>
  );
}
